import React from 'react'
import { CoreInfoUpdated } from '@usap/widgets'

import commaSeparetedValue from '../../../../../../../helpers/commaSeparetedValue'
import {
  StyledCoreContainer, StyledCoreLabel, StyledInfoButton, StyledPopMessageContainer,
} from './CoreWmo.css'

const CoreWmo = ({
  handleShowInformation, product, showInformation, data, staticProps,
}) => (
  <StyledCoreContainer>
    {showInformation && (
    <StyledPopMessageContainer>
      <CoreInfoUpdated forCart config={staticProps?.core} />
    </StyledPopMessageContainer>
    )}
    <StyledCoreLabel>
      Refundable Core: $
      {commaSeparetedValue(data.price.core)}
    </StyledCoreLabel>

    <StyledInfoButton id={`iconClick${product?.productId || ''}`} onClick={handleShowInformation}>
      What’s This?
    </StyledInfoButton>
  </StyledCoreContainer>
)

export default CoreWmo
